<template>
  <div id="app">
    <router-view style="flex: 1;"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    handleOpen(){

    },
    handleClose(){

    }
  }
}
</script>

<style>
/* import global css */
@import './common/main.css';

/* global font setting */
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue